// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oEgSP{background:#fff;height:100%;font-family:"Inter",sans-serif}
@media(max-width: 768px){.oEgSP{padding:20px;overflow-y:auto}}
.zUGTP{font-weight:700;font-size:42px;color:#0f172a;letter-spacing:-0.2px;line-height:125%;font-size:42px}
@media(max-width: 768px){.zUGTP{font-size:32px}}
.xlriu{margin-top:25px;font-weight:500;font-size:22px;color:#1e293b;opacity:.7;letter-spacing:-0.2px;line-height:150%}
.vPo4z{font-family:"Inter",sans-serif;font-size:16px;font-weight:500;color:#0f172a}
.FVNZJ{font-weight:500;color:#0f172a}
.VV3eZ{color:#ed4f9d;font-size:16px;font-weight:500;margin-top:10px;padding:12px;background-color:#fef2f2;border:1px solid #fecaca;border-radius:8px;font-family:"Inter",sans-serif}
.RmgqS{color:hsl(215,20.2247191011%,60.0980392157%);font-weight:400;font-size:16px}
.dkVnV{color:#0078d4;font-weight:600;text-decoration:none;-webkit-transition:color .3s ease;-o-transition:color .3s ease;transition:color .3s ease}
.dkVnV:hover{color:rgb(0,91.1320754717,161)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightPanel": `oEgSP`,
	"title": `zUGTP`,
	"subtitle": `xlriu`,
	"termAndConditionCheckbox": `vPo4z`,
	"boldAndBlack": `FVNZJ`,
	"errorMessage": `VV3eZ`,
	"loginText": `RmgqS`,
	"loginLink": `dkVnV`
};
module.exports = ___CSS_LOADER_EXPORT___;
